/**
 * A logged-in user goes straight into the course — to where they left off, or
 * to the entry unit if they have not started. Only anonymous visitors see the
 * landing page, which is also what crawlers get: the redirect is client-side,
 * so gating it on anything a crawler could satisfy would be cloaking.
 *
 * A logged-in non-subscriber still lands on the landing page for courses whose
 * entry unit is not a free preview — /courses/:slug/ 403s there, so the caller
 * has no URL to send them to.
 */
export function shouldResume({ isLoggedIn }) {
	return Boolean(isLoggedIn);
}
